
<div class="event-wrap" (click)="showDetail(event);" [class.expanded]="event.isExpanded">

    <div class="row event-info">
        <div class="name-wrap">
            <div class="super-bet" *ngIf="event.mappingType == eventMappingTypeEnum.SuperBetEvent">{{dynamicTranslations.specialOfferEventsShorcutSuperBet}}</div>
            <div class="event-of-day" *ngIf="event.mappingType == eventMappingTypeEnum.EventOfDay">{{dynamicTranslations.specialOfferEventsShorcutEventOfDay}}</div>
            <div class="name">{{event.eventName}}</div>
        </div>
        <div class="date-time">{{event.eventDate}} {{event.eventTime}}</div>
    </div>

    <article class="row" *ngIf="!event.isExpanded">
        <div class="bet-type-wrap" *ngIf="event.eventType != eventTypeEnum.Outright; else outright">
            <ng-container *ngIf="betTypeGroupingTemplateItems[0]; let betTypeGroupingTemplateItem">
                <ng-container *ngIf="betsAndOutcomes?.bets && betsAndOutcomes?.bets[betTypeGroupingTemplateItem.betTypeId]; let bet; else emptyBet">
                    <div class="bet-type-col">
                        <ng-container *ngFor="let betTypeOutcome of betTypeGroupingTemplateItem.betTypeOutcomes;  let i = index;">
                        <ng-container *ngIf="i<3">

                            <!-- <h2>{{j}}</h2> -->
                            <span class="outcome-wrap sbv" *ngIf="bet.sbv && ((i==0 && betTypeGroupingTemplateItem.betTypeOutcomes.length> 2) || (i==1 && betTypeGroupingTemplateItem.betTypeOutcomes.length< 3) ) && betTypeGroupingTemplateItem.sbvDisplayType != sbvDispalyTypeEnum.SBVInOutcome">
                              <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                              <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                            </span>
                            <ng-container *ngIf="betsAndOutcomes.betOutcomes[bet.id]
                            && betsAndOutcomes.betOutcomes[bet.id][betTypeOutcome.id]?.length > 0
                            && betsAndOutcomes.betOutcomes[bet.id][betTypeOutcome.id][0].isPlayable
                            && betsAndOutcomes.betOutcomes[bet.id][betTypeOutcome.id][0].odd > 1; else emptyOutcome">
                                <div class="outcome-wrap" [@blink-border]="betsAndOutcomes.betOutcomes[bet.id][betTypeOutcome.id][0].odd" [ngClass]="{'selected': betsAndOutcomes.betOutcomes[bet.id][betTypeOutcome.id][0].isSelected}"
                                (click)="toggleEventOutcome(event, bet, betsAndOutcomes.betOutcomes[bet.id][betTypeOutcome.id][0], betTypeOutcome.name, betTypeGroupingTemplateItem.betTypeName); $event.stopPropagation();">
                                    <span class="outcome-name">
                                        <span class="name">{{betsAndOutcomes.betOutcomes[bet.id][betTypeOutcome.id][0].name}}
                                          <ng-container *ngIf="betTypeGroupingTemplateItem.sbvDisplayType == sbvDispalyTypeEnum.SBVInOutcome && bet.sbv">
                                            <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                                            <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                                          </ng-container>
                                        </span>
                                    </span>
                                    <span class="outcome-odd">
                                        {{betsAndOutcomes.betOutcomes[bet.id][betTypeOutcome.id][0].odd | odd}}
                                    </span>
                                </div>
                            </ng-container>
                            <ng-template #emptyOutcome>
                                <div class="outcome-wrap">
                                    <span class="outcome-name">
                                        <span class="name">{{betTypeOutcome.name}}</span>
                                    </span>
                                    <span class="outcome-odd locked">
                                        <app-svg-icon iconId="lock"></app-svg-icon>
                                    </span>
                                </div>
                            </ng-template>

                            <!-- <span class="outcome-wrap sbv" *ngIf="i==0 && bet.sbv && betTypeGroupingTemplateItem.sbvDisplayType != sbvDispalyTypeEnum.SBVInOutcome">
                              <ng-container *ngIf="!bet.useSbvHandicapPipe">{{bet.sbv}}</ng-container>
                              <ng-container *ngIf="bet.useSbvHandicapPipe">{{bet.sbv | handicapSbv}}</ng-container>
                            </span> -->
                        </ng-container>
                        </ng-container>

                    </div>

                </ng-container>

                <ng-template #emptyBet>
                    <div class="bet-type-col" >
                        <ng-container *ngFor="let i of arr(betTypeGroupingTemplateItem.betTypeOutcomes.length); let j = index">
                            <div class="outcome-wrap">
                                <!-- <span class="outcome-name">{{betTypeOutcome.name}}</span> -->
                                <span class="outcome-odd locked disabled offline">
                                    <!-- null -->
                                    <app-svg-icon iconId="lock"></app-svg-icon>
                                </span>
                                <span class="sbv" *ngIf="j==0 && betTypeGroupingTemplateItem.hasSBV">-</span>
                            </div>
                        </ng-container>
                    </div>
                </ng-template>



            </ng-container>

        </div>

        <ng-template #outright>
          <div class="bet-type-wrap">
            <div class="bet-type-col">
              <div class="outcome-wrap" (click)="showDetail(event); $event.stopPropagation();">
                <span class="outcome-odd" i18n="Long term offer button@@LongTermOffer">
                  DUGOROCNA PONUDA
                </span>
              </div>
            </div>
          </div>
        </ng-template>

        <div class="expand-event" [class.live]="event.isLive">+{{event.betsCount}}</div>

    </article>
</div>
